export default __webpack_public_path__ + "static/media/DannaHerrick.ae432b4b.jpg";